import BackgroundColor from "%/dynamic-component-editor/options/background-color";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

// Plan sheet segmented control: an unselected segment's fill.
export default class UnselectedBackgroundColor extends BackgroundColor {
  static userInterfaceComponent = {
    label: "Unselected Background",
    component: inspectorTools.COLOR_PICKER,
    props: {
      width: "fill",
      displayAsSelectInput: true,
      colorContext: "Backgrounds",
    },
  };

  static defaultValue = {
    value: "transparent.100",
    source: "palette.background",
  };
}
